import { render, staticRenderFns } from "./GrandArena.vue?vue&type=template&id=dfe0fbc4&scoped=true&"
import script from "./GrandArena.vue?vue&type=script&lang=js&"
export * from "./GrandArena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe0fbc4",
  null
  
)

export default component.exports